import axios from 'axios';

export default {
    methods: {
        async vendedoresList(ok, err) {
            try {
                let r = await axios.post('vendedores/list');
                ok(r.data)
            } catch (r) {
                err(r)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/micro/vendedores.js